import * as React from 'react'
import { useHistory } from 'react-router-dom';
import axios from 'axios'

//This component allow visitor to register and create its user profile
export const Register: React.FunctionComponent = (props) => {

    let registerJSON = {}
    let history = useHistory()

    const submitRegister= () => {
        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/registration/', registerJSON,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        .then(function (response) {
            alert("Votre compte a bien été créé ! Vous pouvez maintenant vous connecter.")
            history.push('/connexion')
        })
        .catch(function(error) {
            console.log(error.response)
            if(error.response) {
                if(error.response.data) {
                    let errorObject = error.response.data
                    let errorMessage = "Une ou plusieurs erreurs sont survenues : " 
                    for (const property in errorObject) {
                        let propertyMessage = "\n - " + errorObject[property]
                        errorMessage += propertyMessage
                    }
                    alert(errorMessage)
                }
                else {
                    alert('Une erreur est survenue ! Veuillez réessayer.')
                }
            } else {
                alert('Une erreur est survenue ! Veuillez réessayer.')
            }
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        if (event.target.username.value && event.target.email.value && event.target.password.value && event.target.passwordRepeat.value) {
            if (event.target.password.value === event.target.passwordRepeat.value) {
                if (event.target.email.value === event.target.emailRepeat.value) {
                    if(!/\s/.test(event.target.username.value)) {
                        registerJSON = {
                            "username": event.target.username.value,
                            "password1": event.target.password.value,
                            "password2": event.target.passwordRepeat.value,
                            "email": event.target.email.value
                        }
                        submitRegister()
                    }
                    else {
                        alert("Votre nom d'utilisateur ne peut contenir d'espace !")
                    }
                }
                else {
                    alert("Vous devez saisir deux fois la même adresse email !")
                }
            }
            else {
                alert('Vous devez saisir deux fois le même mot de passe !')
            }
        }
        else {
            alert('Vous devez remplir tous les champs !')
        } 
    }

    return(
        <div className="Connect">
            <h2>Création d'un compte</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="text" name="username" placeholder="Nom d'utilisateur" />
                </label><br />
                <label>
                    <input type="email" name="email" placeholder="Email" />                    
                </label><br />
                <label>
                    <input type="email" name="emailRepeat" placeholder="Répéter email" />                    
                </label><br />
                <label>
                    <input type="password" name="password" placeholder="Mot de passe (8 caractères ou +)"/>
                </label><br />
                <label>
                    <input type="password" name="passwordRepeat" placeholder="Répéter mot de passe" />
                </label><br />
                <input type="submit" value="enregistrer" className="ConnectButton Connexion" />
            </form>
        </div>
    )
}